import CartObject from "../helpers/cartUtil";
import Util from "../helpers/util";
import GoogleMapsApi from "../helpers/GoogleMapsApi";
import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";

// Using shared singleton instance
var UtilObject = new Util();
var GoogleMapsApiObject = new GoogleMapsApi();
var addressDetails;
var customerID, customerData;
var oldPhone, oldEmail, OTP, oldLat, oldLong, customerAddressId;
var deviceTypeCustSerOrdersPage;
var helpList;
var helpRequestedOrderID = null;
var pages;
var cancelOrderId;
export default class accountPageServicing {
  constructor() {
    window.accountPage = this;
    this.allCookies = UtilObject.getAllCookies();
    //id's of the fields
    this.fullNameDisplayDesk = $("#fullNameDisplayDeskCustomerServicing");
    this.genderDisplayDesk = $("#genderDisplayDeskCustomerServicing");
    this.dobDisplayDesk = $("#dobDisplayDeskCustomerServicing");
    this.mobNoDisplayDesk = $("#mobNoDisplayDeskCustomerServicing");
    this.emailIdDisplayDesk = $("#emailIdDisplayDeskCustomerServicing");
    this.passwordConfirmationPage = $("#passwordConfirmationPage");
    this.passwordConfirmationPageBtn = $("#passwordConfirmationPageBtn");

    //OTP MODAL
    // this.verifyOtpModal = $("#verifyOtpModalAccount");
    this.otpInputVerify = $("#otpInputVerifyAccount");
    this.otpError = $("#otpErrorAccount");
    this.verifyOTPBtn = $("#verify-OTP-btn-Account");

    //errors
    this.fullNameDisplayDeskError = $(
      "#fullNameDisplayDeskErrorCustomerServicing",
    );

    this.mobNoDisplayDeskError = $("#mobNoDisplayDeskErrorCustomerServicing");

    this.emailIdDisplayDeskError = $(
      "#emailIdDisplayDeskErrorCustomerServicing",
    );

    this.genderDisplayDeskError = $("#genderDisplayDeskErrorCustomerServicing");

    this.dobDisplayDeskError = $("#dobDisplayDeskErrorCustomerServicing");

    this.passwordConfirmationPageError = $("#passwordConfirmationPageError");

    //button register profile
    this.ProfileUploadBtn = $("#ProfileUploadBtn");

    //security page stuff
    this.forgotpassModalForServicingSecurityPage = $(
      "#forgotpassModalForServicingSecurityPage",
    );
    //forgot password
    this.callForgetPasswordmodalAccountPageBtn = $(
      ".callForgetPasswordmodalAccountPageBtn",
    );
    //change password toggle
    this.toggleChangePasswordBtn = $("#toggleChangePasswordBtn");
    this.forgotBtn = $("#forgotBtnAccount");
    this.Current_Password = $("#Current_PasswordAccount");
    this.New_Password = $("#New_Password");
    this.Confirm_Password = $("#Confirm_PasswordAccount");
    //otp forgot password
    this.forgotPswdMobileNumberInput = $(".customerServicingUPhone");
    this.sendOTPForgotPasswordButton = $("#send-otp-ForgetPasswordAccount");
    this.OTPInputForgotPassword = $("#otp-inputForgetPasswordAccount");
    this.saveNewPasswordBtnForgotPassword = $(
      "#saveNewForgetPasswordAccountBtn",
    );
    this.saveNewPasswordInputForgotPassword = $("#newForgetPasswordAccount");
    this.verifyOTPBtnForgotPassword = $("#saveNewPasswordAccountVerifyBtn");
    this.OTPSuccessForgotPassword = $("#OTP-successAccount");
    this.mobileLabelForgotPassword = $("#mobile-labelForgetPasswordAccount");
    this.OTPLabelForgotPassword = $("#otp-labelForgetPasswordAccount");
    this.newPasswordLabelForgotPassword = $(
      "#new-password-labelForgetPasswordAccount",
    );
    this.successNewPasswordForgotPassword = $("#success-New-PasswordAccount");

    //adress validation
    this.inputAddressName = $(".inputAddressNameChangeAccount");
    this.inputAddress = $(".inputAddressChangeAccount");
    this.inputAddressshort = $(".inputAddressshortChangeAccount");
    this.inputCity = $(".inputCityChangeAccount");
    this.inputState = $(".inputStateChangeAccount");
    this.inputPincode = $(".inputPincodeChangeAccount");

    this.inputAddressNameError = $(".inputAddressNameErrorAccount");
    this.inputAddressError = $(".inputAddressErrorAccount");
    this.inputAddressshortError = $(".inputAddressshortErrorAccount");
    this.inputCityError = $(".inputCityErrorAccount");
    this.inputStateError = $(".inputStateErrorAccount");
    this.inputpincodeError = $(".inputpincodeErrorAccount");

    //Edit adress validation
    this.inputAddressNameEdit = $(".inputAddressNameChangeAccountEdit");
    this.inputAddressEdit = $(".inputAddressChangeAccountEdit");
    this.inputAddressshortEdit = $(".inputAddressshortChangeAccountEdit");
    this.inputCityEdit = $(".inputCityChangeAccountEdit");
    this.inputStateEdit = $(".inputStateChangeAccountEdit");
    this.inputPincodeEdit = $(".inputPincodeChangeAccountEdit");

    this.inputAddressNameErrorEdit = $(".inputAddressNameErrorAccountEdit");
    this.inputAddressErrorEdit = $(".inputAddressErrorAccountEdit");
    this.inputAddressshortErrorEdit = $(".inputAddressshortErrorAccountEdit");
    this.inputCityErrorEdit = $(".inputCityErrorAccountEdit");
    this.inputStateErrorEdit = $(".inputStateErrorAccountEdit");
    this.inputpincodeErrorEdit = $(".inputpincodeErrorAccountEdit");

    //upload btn for security page
    this.uploadBtnforSecPage = $("#uploadBtnforSecPage");

    //show the fields once toggle btn is enabled
    this.showTheFieldsAfterToggle = $("#showTheFieldsAfterToggle");

    //submit btn for sec page
    this.uploadBtnforSecPage = $("#uploadBtnforSecPage");

    //error msgs
    this.Current_PasswordError = $("#Current_PasswordError");
    this.New_PasswordError = $("#New_PasswordError");
    this.Confirm_PasswordError = $("#Confirm_PasswordError");

    //all pages show and d-none id's -Orders
    this.DesktopPastOrder = $("#DesktopPastOrder");
    this.MobilePastOrder = $("#MobilePastOrder");

    //all pages show and d-none id's- favourites

    this.DesktopFavourites = $("#DesktopFavourites");
    this.MobileFavourites = $("#MobileFavourites");

    //all pages show and d-none id's- address
    this.EditDeleteBtnDesktop = $("#EditDeleteBtnDesktop");
    this.EditDeleteBtnMobile = $("#EditDeleteBtnMobile");

    //photo
    this.mobilePhoto = $("#mobilePhoto");
    this.desktopPhoto = $("#desktopPhoto");

    //desktop customer servicing haeder

    // this.custSerHeaderMobOne = $("#custSerHeaderMobOne");
    // this.custSerHeaderOne = $("#custSerHeaderOne");

    //Registering Events
    this.confirmLogInOfCustomer();

    //for the modal to reappear again
    $("#profilePhotoUpdate").on("click", () => {
      $("#profilePhotoUpdate").addClass("in");
    });
  }

  confirmLogInOfCustomer = async () => {
    try {
      customerID = await UtilObject.getCookie("CUSTOMER_ID");

      var pageCookies = this.allCookies;

      if (customerID != null) {
        localStorage.setItem("CUSTOMER_ID", customerID);
        await this.bindEvents();
        await this.checkHelpRequested(pageCookies);

        // Handle browser back/forward buttons
        window.onpopstate = () => {
          this.checkHelpRequested({});
        };
      } else {
        window.$(".customerAcccountPageModalIfUserNotLoggedIn").modal("show");
      }
    } catch (error) {
      console.error("Error in confirmLogInOfCustomer:", error);
    }
  };

  checkHelpRequested = async (pageCookies) => {
    const section = new URLSearchParams(window.location.search).get("section");
    
    if (section) {
      const sectionMap = {
        'orders': 'nav-orders',
        'profile': 'nav-profile',
        'security': 'nav-security',
        'address': 'nav-address',
        'favourites': 'nav-favourites',
        'offers': 'nav-offers',
        'help': 'nav-help',
        'quote-requests': 'nav-quote-requests',
        'dashboard': 'nav-dashboard'
      };

      const targetNav = sectionMap[section];
      if (targetNav) {
        const $target = $(`.${targetNav}`).first();
        if ($target.length) {
          // Manually trigger the sidebar function logic
          this.sidebarFunction({ currentTarget: $target[0] });
          return;
        }
      }
    }

    if (pageCookies.hasOwnProperty("HELP_REQUESTED")) {
      helpRequestedOrderID = pageCookies.HELP_REQUESTED;
      this.sidebarFunction({ currentTarget: $(".nav-help")[0] });
    } else if (pageCookies.hasOwnProperty("OFFER_CHECK")) {
      this.sidebarFunction({ currentTarget: $(".nav-offers")[0] });
    } else {
      $(".currentlyActive").removeClass("d-none");
      var activeEvent = $("#sidebarMenu").find(".active");
      activeEvent.removeClass("active");
      $(".nav-dashboard").addClass("active");
      await this.runRequiredFunctions("nav-dashboard");
    }
  };

  bindEvents = async () => {
    this.ProfileUploadBtn.on("click", this.doFormAction);

    //toggle btn onclick function
    this.toggleChangePasswordBtn.on("click", this.showOtherFieldsAction);

    //submit btn for sec
    this.uploadBtnforSecPage.on("click", this.securityPageValidation);

    //upload profile
    //$(window).on("load", () => { this.getAccountDetails(); });
    this.passwordConfirmationPageBtn.on("click", this.submitPasswordCheck);

    //verify OTP
    this.verifyOTPBtn.on("click", this.verifyOtp);

    //forgot password
    this.sendOTPForgotPasswordButton.on("click", this.sendOtpForgotPassword);
    this.saveNewPasswordBtnForgotPassword.on(
      "click",
      this.doSaveNewForgotPassword,
    );
    this.verifyOTPBtnForgotPassword.on("click", this.doVerifyOTP);

    //adding new address
    $(".accountAdressSubmitButton").on("click", this.addAdressValidationCheck);

    //editing old addres
    $(".accountAdressEditButton").on("click", this.editAdressValidationCheck);

    $(".deleteAddressAccount").on("click", this.deleteAddressDeleteAccount);

    //widthwise show and d-none for Past orders
    // for desktop - bigger and mobile and tab view - smaller
    var w = $(window).width();

    if (w < 990) {
      $(".orange-header").removeClass("mt-6");
      $(".orange-header").addClass("mt-1");
    } else {
      $(".orange-header").removeClass("mt-1");
      $(".orange-header").addClass("mt-6");
    }

    this.noOfProductsInCart = await CartObject.cartCheck();

    const cartCount = (this.noOfProductsInCart && this.noOfProductsInCart.Products) ? this.noOfProductsInCart.Products.length : 0;
    $("span.cartCountAS").html(`${cartCount}`);

    // for desktop - bigger and mobile and tab view - smaller
    // var newHeader = $(window).width();
    //

    // if (newHeader < 821) {
    //   this.custSerHeaderOne.addClass("d-none");
    //   this.custSerHeaderMobOne.removeClass("d-none");
    // } else {
    //   this.custSerHeaderMobOne.addClass("d-none");
    //   this.custSerHeaderOne.removeClass("d-none");
    // }

    // for desktop and tab view - bigger and mobile- smaller
    var width_fav = $(window).width();

    if (width_fav < 573) {
      this.DesktopFavourites.addClass("d-none");
      this.MobileFavourites.removeClass("d-none");
    } else {
      this.MobileFavourites.addClass("d-none");
      this.DesktopFavourites.removeClass("d-none");
    }

    // address
    var width_address = $(window).width();

    if (width_address < 821) {
      this.EditDeleteBtnDesktop.addClass("d-none");
      this.EditDeleteBtnMobile.removeClass("d-none");
    } else {
      this.EditDeleteBtnMobile.addClass("d-none");
      this.EditDeleteBtnDesktop.removeClass("d-none");
    }

    // admin phtoto
    var width_photo = $(window).width();

    if (width_photo < 573) {
      this.desktopPhoto.addClass("d-none");
      this.mobilePhoto.removeClass("d-none");
    } else {
      this.mobilePhoto.addClass("d-none");
      this.desktopPhoto.removeClass("d-none");
    }

    //checking the size of the screen
    var screenWidthOrders = $(window).width();

    if (screenWidthOrders < 768) {
      //show mobile view

      deviceTypeCustSerOrdersPage = "mobile";
      $("#MobilePastOrder").removeClass("d-none");
    } else {
      deviceTypeCustSerOrdersPage = "desktop";
      $("#DesktopPastOrder").removeClass("d-none");
    }

    //calling past orders api
    //$(window).on("load", () => { this.order_list(); });

    //calling help section
    //$(window).on("load", () => { this.customerHelpList(); });

    //calling address api
    //$(window).on("load", () => { this.showCustomerAddress(); });

    //$(window).on("load", () => { this.customerFavouriteList(); });

    //$(window).on("load", () => { this.getAllCoupons(); });

    //Onclick empty cart on orders page
    $(".customerDeleteCartModalSubmitButton").on(
      "click",
      this.reOrderAfterEmptyCartFunction,
    );

    //goggle maps
    $(".toggleMap").on("click", this.toggleGoogleMaps);
    if (screenWidthOrders < 991) {
      $("#sidebarMenu").css("margin-top", "7rem");
    } else {
      $("#sidebarMenu").css("margin-top", "5rem");
    }

    //$("#inviteFriendsBtnDesktop").on("click", this.shareReferralCode);

    $(".deleteAddressAccount").on("click", this.deleteAddressDeleteAccount);

    //Click events for sidebar
    $(".nav-orders").on("click", this.sidebarFunction);
    $(".nav-dashboard").on("click", this.sidebarFunction);
    $(".dashboard-card, .dashboard-nav-shortcut").on("click", this.sidebarFunction);
    $(".nav-account").on("click", this.sidebarFunction);
    $(".nav-profile").on("click", this.sidebarFunction);
    $(".nav-security").on("click", this.sidebarFunction);
    $(".nav-address").on("click", this.sidebarFunction);
    $(".nav-favourites").on("click", this.sidebarFunction);
    $(".nav-offers").on("click", this.sidebarFunction);
    $(".nav-referral").on("click", this.sidebarFunction);
    $(".nav-help").on("click", this.sidebarFunction);
    $(".nav-myquotes").on("click", this.sidebarFunction);
    $(".nav-requestedquotes").on("click", this.sidebarFunction);
    $(".nav-tracking").on("click", this.sidebarFunction);
    $(".nav-quote-requests").on("click", this.sidebarFunction);
    $(".nav-logOut").on("click", () => {
      this.redirectToLogIn();
    });

    //log out - use arrow function to preserve 'this' context
    $(".logOutUserBtn").on("click", () => {
      this.redirectToLogIn();
    });

    if (w < 991) {
      $(".orange-header").removeClass("mt-6");
      $(".orange-header").addClass("mt-1");
    } else {
      $(".orange-header").removeClass("mt-1");
      $(".orange-header").addClass("mt-6");
    }

    //upload profile image
    $(".profileImageUpload").on("click", this.profileImageUpload);

    //need account details for header
    this.getAccountDetails();
  };

  sidebarFunction = async (event) => {
    // Determine the page identifier from data-page or class list
    var page = $(event.currentTarget).attr("data-page");
    if (!page) {
      const classes = Array.from(event.currentTarget.classList);
      page = classes.find(c => c.startsWith("nav-") && c !== "nav-item" && c !== "nav-link") || 
             classes[classes.length - 1];
    }

    if (!page || page === "active") return;

    var activeEvent = $("#sidebarMenu").find(".active");
    activeEvent.removeClass("active");

    if (page == "nav-account" || page == "collapsed") {
      $(event.currentTarget).addClass("active");
    } else {
      // Set active on sidebar item if clicked from dashboard card or shortcut
      if ($(event.currentTarget).hasClass("dashboard-card") || $(event.currentTarget).hasClass("dashboard-nav-shortcut")) {
        $(`#sidebarMenu .${page}`).addClass("active");
      } else {
        $(event.currentTarget).addClass("active");
      }
      
      // Update URL without reloading the page
    const sectionName = page.replace('nav-', '');
    const newUrl = window.location.pathname + (sectionName !== 'dashboard' ? '?section=' + sectionName : '');
    if (window.location.search !== (sectionName !== 'dashboard' ? '?section=' + sectionName : '')) {
      history.pushState({ section: sectionName }, '', newUrl);
    }

    $(".currentlyActive").addClass("d-none");
      $(".currentlyActive").removeClass("currentlyActive");
      $("#sidebarMenu").removeClass("show");

      // Show/Hide back button based on page
      if (page === "nav-dashboard") {
        $("#sectionBackButton").addClass("d-none");
      } else {
        $("#sectionBackButton").removeClass("d-none");
      }
    }

    if (page == "nav-orders") {
      $(".customerServicingOrders").addClass("currentlyActive");
      $(".customerServicingOrders").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-dashboard") {
      $(".customerAccountDashboard").addClass("currentlyActive");
      $(".customerAccountDashboard").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-profile") {
      $(".customerAccountProfile").addClass("currentlyActive");
      $(".customerAccountProfile").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-security") {
      $(".custAccountSecurity").addClass("currentlyActive");
      $(".custAccountSecurity").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-address") {
      $(".custAccountAddress").addClass("currentlyActive");
      $(".custAccountAddress").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-favourites") {
      $(".customerServicingFavorites").addClass("currentlyActive");
      $(".customerServicingFavorites").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-offers") {
      $(".custSerOffers").addClass("currentlyActive");
      $(".custSerOffers").removeClass("d-none");
    } else if (page == "nav-referral") {
      $(".custSerRefferalPage").addClass("currentlyActive");
      $(".custSerRefferalPage").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-help") {
      $(".customerConfirmationHelpPageDesktop").addClass("currentlyActive");
      $(".customerConfirmationHelpPageDesktop").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-myquotes") {
      $(".customerMyQuotes").addClass("currentlyActive");
      $(".customerMyQuotes").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-requestedquotes") {
      $(".customerRequestedQuotes").addClass("currentlyActive");
      $(".customerRequestedQuotes").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-tracking") {
      $(".customerTrackingQuotes").addClass("currentlyActive");
      $(".customerTrackingQuotes").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-quote-requests") {
      $(".customerQuoteRequestsPage").addClass("currentlyActive");
      $(".customerQuoteRequestsPage").removeClass("d-none");
      this.unsetOfferCheck();
    } else if (page == "nav-logOut") {
      this.redirectToLogIn();
      return;
    }

    await this.runRequiredFunctions(page);
  };

  runRequiredFunctions = async (page) => {
    if (page == "nav-orders") {
      await this.order_list();
    } else if (page == "nav-address") {
      await this.showCustomerAddress();
    } else if (page == "nav-favourites") {
      await this.customerFavouriteList();
    } else if (page == "nav-offers") {
      await this.getAllCoupons();
    } else if (page == "nav-help") {
      await this.customerHelpList();
    } else if (page == "nav-myquotes") {
      await this.loadCustomerLiveQuotes();
    } else if (page == "nav-requestedquotes") {
      await this.loadCustomerRequestedQuotes();
    } else if (page == "nav-tracking") {
      await this.loadCustomerTrackingQuotes();
    } else if (page == "nav-dashboard") {
      await this.populateDashboardStats();
    }
  };

  navigateToDashboard = () => {
    // Manually trigger the sidebar function logic for the dashboard
    this.sidebarFunction({ currentTarget: $('<div data-page="nav-dashboard"></div>')[0] });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  populateDashboardStats = async () => {
    // 1. Enquiries Count
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderListCount",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $(".count-enquiries").html(result["Total_Customer_Orders"] || 0);
      }
    });

    // 2. Address Count
    $.ajax({
      url: baseURL + "api/customer/Account/getAddress",
      type: "POST",
      data: { Customer_ID: customerID },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $(".count-addresses").html(Array.isArray(result) ? result.length : 0);
      }
    });

    // 3. Favourites Count
    $.ajax({
      url: baseURL + "api/customer/Account/getFavorites",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $(".count-favorites").html(Array.isArray(result) ? result.length : 0);
      }
    });

    // 4. Recent Activity (Last 3 Orders)
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderListWithOffset",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: { Offset: 0 },
      success: (result) => {
        const container = $("#dashboardRecentActivity");
        container.empty();
        if (result && Array.isArray(result) && result.length > 0) {
          result.slice(0, 3).forEach(order => {
            const item = `<div class="recent-activity-item shadow-sm">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h6 class="fw-bold mb-1">${order.Vendor_Name}</h6>
                  <p class="small text-muted mb-1">#${order.Order_No} | ${order.Order_Status}</p>
                  <p class="small mb-0 text-danger fw-bold">₹ ${order.Total_Amount}</p>
                </div>
                <span class="badge bg-light text-dark small">${order.Booked_Date_and_Time.split(' ')[0]}</span>
              </div>
            </div>`;
            container.append(item);
          });
        } else {
          container.html('<div class="text-center py-4 text-muted small">No recent activity</div>');
        }
      },
      error: () => {
        $("#dashboardRecentActivity").html('<div class="text-center py-4 text-danger small">Failed to load activity</div>');
      }
    });
  };

  loadCustomerLiveQuotes = async () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/myRequests",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      data: { Customer_ID: customerID },
      success: (result) => {
        $(".quote_display").empty();
        if (result && result.success && Array.isArray(result.data) && result.data.length > 0) {
          $(".quote_display").removeClass("d-none");
          $("#no_Live_Quotes").addClass("d-none");
          result.data.forEach((element) => {
            var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
              <div class="card-body">
                <div class="row">
                  <div class="col-8">
                    <h5 class="mb-1">${element.Product_Name || "Quote"} | #${element.Quote_No || element.Quote_Request_ID || ""}</h5>
                    <p class="mb-1">${element.Sub_Category || ""}</p>
                    <p class="mb-0 text-muted">Qty: ${element.Quantity || 0} ${element.Units || ""} | Budget: ${element.Low_Budget || element.budget_min || 0} - ${element.High_Budget || element.budget_max || 0}</p>
                  </div>
                  <div class="col-4 text-end">
                    <p class="mb-1">Status: ${element.status || element.Order_Status || "-"}</p>
                    <p class="mb-0 text-muted">${element.CreatedDate || element.createdAt || ""}</p>
                  </div>
                </div>
              </div>
            </div>`;
            $(".quote_display").append(item);
          });
        } else {
          $(".quote_display").addClass("d-none");
          $("#no_Live_Quotes").removeClass("d-none");
        }
      },
      error: () => {
        $(".quote_display").empty();
        $(".quote_display").addClass("d-none");
        $("#no_Live_Quotes").removeClass("d-none");
      },
    });
  };

  loadCustomerRequestedQuotes = async () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/quotes",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      data: { Customer_ID: customerID },
      success: (result) => {
        $(".requested_quote_display").empty();
        if (result && result.success && Array.isArray(result.data) && result.data.length > 0) {
          $(".requested_quote_display").removeClass("d-none");
          $("#no_Requested_Quotes").addClass("d-none");
          result.data.forEach((element) => {
            var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
              <div class="card-body">
                <div class="row">
                  <div class="col-8">
                    <h5 class="mb-1">${element.Product_Name || "Quote"} | #${element.Quote_No || element.Quote_ID || ""}</h5>
                    <p class="mb-1">${element.Sub_Category || ""}</p>
                    <p class="mb-0 text-muted">Qty: ${element.Quantity || 0} ${element.Units || ""} | Budget: ${element.Low_Budget || 0} - ${element.High_Budget || 0}</p>
                  </div>
                  <div class="col-4 text-end">
                    <p class="mb-1">Status: ${element.status || element.Order_Status || "-"}</p>
                    <p class="mb-0 text-muted">${element.CreatedDate || ""}</p>
                  </div>
                </div>
              </div>
            </div>`;
            $(".requested_quote_display").append(item);
          });
        } else {
          $(".requested_quote_display").addClass("d-none");
          $("#no_Requested_Quotes").removeClass("d-none");
        }
      },
      error: () => {
        $(".requested_quote_display").empty();
        $(".requested_quote_display").addClass("d-none");
        $("#no_Requested_Quotes").removeClass("d-none");
      },
    });
  };

  loadCustomerTrackingQuotes = async () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerQuote/orders",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      data: { Customer_ID: customerID },
      success: (result) => {
        $("#DesktopTracking").empty();
        if (result && result.success && Array.isArray(result.data) && result.data.length > 0) {
          $("#trackingQuotes").removeClass("d-none");
          $("#DesktopTracking").removeClass("d-none");
          $("#notrackingQuotes").addClass("d-none");
          result.data.forEach((element) => {
            var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
              <div class="card-body">
                <div class="row">
                  <div class="col-8">
                    <h5 class="mb-1">${element.Product_Name || "Quote"} | Tracking #${element.Tracking_No || element.Order_ID || ""}</h5>
                    <p class="mb-0 text-muted">Qty: ${element.Quantity || 0} | Budget: ${element.Low_Budget || 0} - ${element.High_Budget || 0}</p>
                  </div>
                  <div class="col-4 text-end">
                    <p class="mb-1">Status: ${element.Tracking_Status || element.Order_Status || "-"}</p>
                    <p class="mb-0 text-muted">${element.Created_At || element.updatedAt || ""}</p>
                  </div>
                </div>
              </div>
            </div>`;
            $("#DesktopTracking").append(item);
          });
        } else {
          $("#trackingQuotes").addClass("d-none");
          $("#notrackingQuotes").removeClass("d-none");
        }
      },
      error: () => {
        $("#DesktopTracking").empty();
        $("#trackingQuotes").addClass("d-none");
        $("#notrackingQuotes").removeClass("d-none");
      },
    });
  };

  unsetOfferCheck = () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerCookies/unsetSessionValues",
      type: "POST",
      data: {
        unset: "OFFER_CHECK",
      },
      success: (result) => {},
      error: (error) => {},
    });
  };

  toggleGoogleMaps = async (event) => {
    var classList = event.target.className.split(" ");
    var idOfGoogleMapsDiv = classList[classList.length - 1];

    addressDetails = await GoogleMapsApiObject.initModal(idOfGoogleMapsDiv);
  };

  showOtherFieldsAction = (e) => {
    e.preventDefault();

    if (e.currentTarget.ariaPressed == "true") {
      this.showTheFieldsAfterToggle.addClass("d-none");
      //e.currentTarget.setAttribute("aria-pressed","false")
    } else if (e.currentTarget.ariaPressed == "false") {
      this.showTheFieldsAfterToggle.removeClass("d-none");
      //e.currentTarget.setAttribute("aria-pressed","true")
    }

    //this.showTheFieldsAfterToggle.removeClass("d-none");
  };

  //checking if entered details are valid or not
  doFormAction = async (e) => {
    e.preventDefault();

    //name
    let isNameValidated = this.Name_validate();
    if (isNameValidated) {
      this.fullNameDisplayDeskError.html("");
    }

    //gender
    let isGenderValidated = this.Gender_validate();
    if (isGenderValidated) {
      this.genderDisplayDeskError.html("");
    }

    //dob
    let isDobValidated = this.Dob_validate();
    if (isDobValidated) {
      this.dobDisplayDeskError.html("");
    }

    //mobNo
    let isMobNoValidated = this.MobNo_validate();
    if (isMobNoValidated) {
      this.mobNoDisplayDeskError.html("");
    }

    //emailid
    let isEmailValidated = this.Email_validate();
    if (isEmailValidated) {
      this.emailIdDisplayDeskError.html("");
    }

    //checking if all fields are right
    if (isNameValidated && isMobNoValidated && isEmailValidated) {
      let phnoIsUnique = await this.phnoIsUnique_validate();
      let emailIsUnique = await this.emailIsUnique_validate();

      if (phnoIsUnique && emailIsUnique) {
        this.emailIdDisplayDeskError.html("");
        this.mobNoDisplayDeskError.html("");

        window.$("#checkPasswordConfirmationPage").modal("show");
      }
    }
  };

  //validate function
  MobNo_validate = () => {
    let flag = true;
    var phoneno = /^\d{10}$/;
    if (!this.mobNoDisplayDesk.val().match(phoneno)) {
      this.mobNoDisplayDeskError.html(
        "Please enter only 10 digits for mobile number",
      );

      flag = false;
    }

    return flag;
  };

  Name_validate = () => {
    let flag = true;
    var name = /^([a-zA-Z ]){3,100}$/;

    if (
      !(
        this.fullNameDisplayDesk.val().match(name) &&
        this.fullNameDisplayDesk.val().length >= 3 &&
        this.fullNameDisplayDesk.val().length <= 100
      )
    ) {
      this.fullNameDisplayDeskError.html(
        "Name must be min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  // //gender validation
  Gender_validate = () => {
    let flag = true;

    if (this.genderDisplayDesk.val() == null) {
      this.genderDisplayDeskError.html("Please enter a valid gender");

      flag = false;
    }

    return flag;
  };

  //email id validation
  Email_validate = () => {
    let flag = true;
    var emailexample =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.emailIdDisplayDesk.val().match(emailexample)) {
      this.emailIdDisplayDeskError.html("Please enter a valid email");

      flag = false;
    }

    return flag;
  };

  //dob validation
  Dob_validate = () => {
    let flag = true;

    var dobPattern = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
    if (!this.dobDisplayDesk.val().match(dobPattern)) {
      this.dobDisplayDeskError.html("Please enter a valid birth date");

      flag = false;
    }

    return flag;
  };

  //call to get customer profile
  getAccountDetails = async () => {
    // Customer_ID: customerID,

    $.ajax({
      url: baseURL + "api/customer/Account/GetUserDetails",
      type: "POST",
      data: {
        Customer_ID: customerID,
      },
      headers: { Authorization: "KFvDq77oq74WjKXKon4AIzaSyBzKejuO2tJjzKJ" },
      success: async (result) => {
        customerData = result;
        $(".customerServicingName").val(result.Customer_Name);
        $(".accountNameDisplay").html(result.Customer_Name);
        $(".customerServicingGender").val(result.Gender);
        $(".customerServicingDateOfBirth").val(result.Date_Of_Birth);
        $(".customerServicingUPhone").val(result.Phone_Number);
        $(".customerServicingUEmail").val(result.Email);
        $(".customerServicingSerialNumber").val(result.Serial_Number);

        //ruthvi's code for referal code api integration
        $(".referalCode").html(result.Referral_code);

        //profile image
        if (result.Image_URL == null || result.Image_URL == "") {
          $(".LocasoMainLogo").attr(
            "src",
            `https://img.icons8.com/color/32/null/circled-user-male-skin-type-7--v1.png`,
          );
        } else {
          $(".LocasoMainLogo").attr("src", getImageUrl(result.Image_URL));
        }

        oldPhone = result.Phone_Number;
        oldEmail = result.Email;

        this.changeAccountDisplayOnHeader(result);
      },
      error: (result) => {},
    });
  };

  changeAccountDisplayOnHeader = async (account) => {
    var desktopName = account ? (account.Customer_Name || "") : "";
    if (desktopName.length > 10) {
      desktopName = desktopName.substring(0, 8) + "..";
    }
    //For Desktop Name Change
    $(".accountNameDesktop").html(
      `<a href="${baseURL}customer/account" class="truncate-account-name-desktop" style="color:black;">${desktopName}</a>`,
    );
    // $(".accountNameMobile").html(
    //   `<a href="${baseURL}customer/account" class="truncate-account-name">${result.Customer_Name}</a>`
    // );
    // $(".customerProfileImage").html(
    //   `<img src="https://img.icons8.com/color/32/null/circled-user-male-skin-type-7--v1.png"/>`
    // );

    if (account.Image_URL == null || account.Image_URL == "") {
      const customerName = (account.Customer_Name || "").trim();
      const fallbackInitial =
        customerName.length > 0
          ? customerName.charAt(0).toUpperCase()
          : `<i class="fa-solid fa-user"></i>`;
      const initialMarkup =
        customerName.length > 0
          ? `<span class="locaso-avatar-initial">${fallbackInitial}</span>`
          : fallbackInitial;
      $(".customerProfileImage").html(initialMarkup);
    } else {
      var accountImg = getImageUrl(account.Image_URL);

      $(".customerProfileImage").html(`<img src="${accountImg}"/>`);
    }
  };

  //upload user information
  uploadUpdatedProfile = async () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;
    // Customer_ID: customerID,

    //zero bounce check for email
    var emailValid = "invalid";
    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/customer/CustomerZeroBounce/zeroBounceCheck",
        type: "POST",
        data: {
          basicEmail: this.emailIdDisplayDesk.val(),
        },
        success: (response) => {
          emailValid = response;
          resolve();
        },
        error: (error) => {
          resolve();
        },
      });
    });
    //zero bounce check is over

    //update customer
    $.ajax({
      url: baseURL + "api/customer/Account/UpdateCustomer",
      type: "POST",
      data: {
        Customer_ID: customerID,
        Customer_Name: this.fullNameDisplayDesk.val(),
        Gender: this.genderDisplayDesk.val(),
        Date_Of_Birth: this.dobDisplayDesk.val(),
        Phone_Number: this.mobNoDisplayDesk.val(),
        Email: this.emailIdDisplayDesk.val(),
        Email_Status: emailValid,
      },
      headers: { Authorization: "KFvDq77oq74WjKXKon4AIzaSyBzKejuO2tJjzKJ" },
      success: async (result) => {
        $("#passwordConfirmationPage").val("");
        $("#passwordConfirmationPageError").html("");
        window.$("#checkPasswordConfirmationPage").modal("hide");
        window.$("#profileUpdatedChangedSuccesfully").modal("show");
        await this.getAccountDetails();
      },
      error: (result) => {},
    });
  };

  //check if user has entered a different number
  phnoIsUnique_validate = () => {
    return new Promise((resolve) => {
      if (this.mobNoDisplayDesk.val() == oldPhone) {
        resolve(true);
      } else {
        //Check if phone is unique
        $.ajax({
          type: "POST",
          //check if phone number exists
          url: baseURL + "api/customer/Account/logInPhoneCustomerAccountUpdate",
          headers: { Authorization: X_API_KEY },
          data: {
            Phone_Number: this.mobNoDisplayDesk.val(),
          },
          success: () => {
            resolve(true);
          },
          error: () => {
            this.mobNoDisplayDeskError.html("Phone Number already Exists");
            resolve(false);
          },
        });
      }
    });
  };

  emailIsUnique_validate = () => {
    return new Promise((resolve) => {
      if (this.emailIdDisplayDesk.val() == oldEmail) {
        resolve(true);
      } else {
        //check if email is unique
        $.ajax({
          type: "POST",
          //check if phone number exists
          url:
            baseURL + "api/customer/Account/emailIsUniqueCustomerAccountUpdate",
          headers: { Authorization: X_API_KEY },
          data: {
            cutomerEmail_Address: this.emailIdDisplayDesk.val(),
          },
          success: () => {
            resolve(true);
          },
          error: () => {
            if ($("#emailIdDisplayDeskCustomerServicing").val() == "") {
              this.emailIdDisplayDeskError.html("Email Address is mandatory");
            } else {
              this.emailIdDisplayDeskError.html("Email Address already exists");
            }
            resolve(false);
          },
        });
      }
    });
  };

  //password check
  submitPasswordCheck = async () => {
    $.ajax({
      type: "POST",
      url: baseURL + "api/customer/Account/userPasswordCheck",
      headers: { Authorization: X_API_KEY },
      data: {
        Customer_ID: customerID,
        Password: this.passwordConfirmationPage.val(),
      },
      success: async (res) => {
        var code = res.Code;

        if (code == 2) {
          this.passwordConfirmationPageError.html("Password is incorrect");
        } else {
          //check if number is changed
          if (this.mobNoDisplayDesk.val() == oldPhone) {
            await this.uploadUpdatedProfile();
          } else {
            //number is changed
            window.$("#checkPasswordConfirmationPage").modal("hide");
            window.$("#verifyOtpModalAccount").modal("show");
            await this.sendOtp();
          }
        }
      },
      error: (res) => {},
    });
  };

  sendOtp = () => {
    return new Promise((resolve) => {
      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/sendOTPSignUp",
        headers: { Authorization: X_API_KEY },
        data: {
          Phone_Number: this.mobNoDisplayDesk.val(),
          Email_Address: this.emailIdDisplayDesk.val(),
        },
        success: (data) => {
          OTP = data.OTP;
          resolve(data);
        },
        error: (err) => {
          resolve(null);
        },
      });
    });
  };

  verifyOtp = async () => {
    //OTP = 1234;
    var verifyOtp = /^\d{4}$/;
    if (!this.otpInputVerify.val().match(verifyOtp)) {
      this.otpError.html("Enter the Correct OTP format");
    } else {
      if (OTP == this.otpInputVerify.val()) {
        this.otpError.html("OTP Verified");
        window.$("#verifyOtpModalAccount").modal("hide");
        $("#otpInputVerifyAccount").val("");
        $("#otpErrorAccount").val("");

        //Store Customer details changes in the database
        await this.uploadUpdatedProfile();
      } else {
        this.otpError.html("Enter the Correct OTP");
      }
    }
  };

  //SECURITY PAGE

  securityPageValidation = (e) => {
    e.preventDefault();

    //3 validations
    // if (this.toggleChangePasswordBtn.is(":checked")) {
    //NewPassword
    // let isNewPasswordValidated = this.NewPassword_validate();
    // if (isNewPasswordValidated) {
    //
    //   this.New_PasswordError.html("");
    // }

    //CurrentPassword
    let isCurrentPasswordValidated = this.CurrentPassword_validate();
    if (isCurrentPasswordValidated) {
      this.Current_PasswordError.html("");
    }

    //ConfirmPassword
    let isConfirmPasswordValidated = this.ConfirmPassword_validate();
    if (isConfirmPasswordValidated) {
      this.Confirm_PasswordError.html("");
    }

    if (
      // isNewPasswordValidated &&
      isCurrentPasswordValidated &&
      isConfirmPasswordValidated
    ) {
      this.setNewPassword();
    }
  };

  //validate function
  CurrentPassword_validate = () => {
    let flag = true;

    if (
      !(
        this.Current_Password.val().length >= 6 &&
        this.Current_Password.val().length <= 15
      )
    ) {
      this.Current_PasswordError.html(
        "Password must be min 6 and max 15 characters",
      );

      flag = false;
    }

    return flag;
  };

  //validate function
  // NewPassword_validate = () => {
  //
  //   let flag = true;

  //   if (
  //     !(
  //       this.New_Password.val().length >= 6 &&
  //       this.New_Password.val().length <= 15
  //     )
  //   ) {
  //     this.New_PasswordError.html(
  //       "Password must be min 6 and max 15 characters"
  //     );

  //     flag = false;
  //   }

  //   return flag;
  // };

  //validate function
  ConfirmPassword_validate = () => {
    let flag = true;

    if (
      !(
        this.Confirm_Password.val().length >= 6 &&
        this.Confirm_Password.val().length <= 15
      )
    ) {
      this.Confirm_PasswordError.html(
        "Password must be min 6 and max 15 characters",
      );

      flag = false;
    }

    return flag;
  };

  //password validation
  passwordvalidate1 = () => {
    let flag = true;
    if (
      !(
        this.saveNewPasswordInputForgotPassword.val().length >= 6 &&
        this.saveNewPasswordInputForgotPassword.val().length <= 15
      )
      // ||
      // !this.saveNewPasswordInput.val().match(PasswordExample)
    ) {
      this.successNewPasswordForgotPassword.addClass("text-danger");
      this.successNewPasswordForgotPassword.removeClass("text-success");
      this.successNewPasswordForgotPassword.html(
        "Please use min 6 and max 15 characters",
      );

      flag = false;
    }
    return flag;
  };

  //set new password
  setNewPassword = () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;
    // Customer_ID: customerID,Customer_ID: `1e461723-6723-4772-bdcb-bdb0b9bc3eab`,

    $.ajax({
      type: "POST",
      url: baseURL + "api/customer/Account/userPasswordCheck",
      headers: { Authorization: X_API_KEY },
      data: {
        Customer_ID: customerID,
        Password: this.Current_Password.val(),
      },
      success: (res) => {
        var code = res.Code;

        if (code == 2) {
          this.Current_PasswordError.html("Password is incorrect");
        } else {
          //set new password
          $.ajax({
            type: "POST",
            url: baseURL + "api/customer/Account/setpassword",
            headers: { Authorization: X_API_KEY },
            data: {
              Customer_ID: customerID,
              Password: this.Confirm_Password.val(),
            },
            success: (res) => {
              window.$("#passwordChangedSuccesfully").modal("show");
              $("#Current_PasswordAccount").val("");
              $("#Confirm_PasswordAccount").val("");

              //add redirection to loginpage
              setInterval(() => this.redirectToLogIn(), 500);
            },
            error: (err) => {},
          });
        }
      },
      error: (res) => {},
    });
  };

  eraseLocalStorage = () => {
    localStorage.removeItem("CUSTOMER_ID");
    localStorage.removeItem("ORDER_ID");
  };

  redirectToLogIn = () => {
    // Clear frontend state
    localStorage.clear();

    // Clear cookies forcefully
    document.cookie =
      "CUSTOMER_ID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "ORDER_ID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Optional: backend cleanup (fire & forget)
    $.post(baseURL + "api/customer/CustomerCookies/unsetSessionValues", {
      unset: "CUSTOMER_ID",
    });

    // Redirect
    window.location = baseURL + "customer/login";
  };

  sendOtpForgotPassword = (e) => {
    e.preventDefault();
    $("#mobileInputAccount").attr("disabled", true);
    $.ajax({
      type: "POST",
      url: baseURL + "api/customer/Account/SendOTPForgotPassword",
      data: {
        Phone_Number: oldPhone,
      },
      headers: { Authorization: X_API_KEY },
      success: (data) => {
        // this.phoneNotRegisteredError.html("OTP Sent Succesfully");
        OTP = data.OTP;

        //removinf input for mobile number
        this.mobileLabelForgotPassword.addClass("d-none");
        this.forgotPswdMobileNumberInput.addClass("d-none");
        // this.phoneNotRegisteredError.addClass("d-none");
        this.sendOTPForgotPasswordButton.addClass("d-none");

        //adding input for otp
        this.OTPLabelForgotPassword.removeClass("d-none");
        this.OTPInputForgotPassword.removeClass("d-none");
        this.OTPSuccessForgotPassword.removeClass("d-none");
        this.verifyOTPBtnForgotPassword.removeClass("d-none");
      },
      error: (err) => {
        // var errMessage = err.responseJSON.Msg;
        // this.phoneNotRegisteredError.html(errMessage);
      },
    });
  };

  //validtaions
  doVerifyOTP = () => {
    let isOTPValidated = this.verifyOtpForgotPassword();
    if (isOTPValidated) {
      this.OTPSuccessForgotPassword.addClass("text-success");
      this.OTPSuccessForgotPassword.removeClass("text-danger");
      this.OTPLabelForgotPassword.addClass("d-none");
      this.OTPInputForgotPassword.addClass("d-none");
      this.verifyOTPBtnForgotPassword.addClass("d-none");
      this.OTPSuccessForgotPassword.addClass("d-none");
      this.newPasswordLabelForgotPassword.removeClass("d-none");
      this.saveNewPasswordInputForgotPassword.removeClass("d-none");
      this.saveNewPasswordBtnForgotPassword.removeClass("d-none");
      $("#otp-labelForgetPasswordAccount").val("");
    }
  };

  verifyOtpForgotPassword = () => {
    let flag = true;
    let OTPExample = /^\d{4}$/;
    if (!this.OTPInputForgotPassword.val().match(OTPExample)) {
      flag = false;
      this.OTPSuccessForgotPassword.addClass("text-danger");
      this.OTPSuccessForgotPassword.removeClass("text-success");
      this.OTPSuccessForgotPassword.html("Enter 4 digit number only ");
    } else {
      if (OTP == this.OTPInputForgotPassword.val()) {
        flag = true;
      } else {
        flag = false;
        this.OTPSuccessForgotPassword.addClass("text-danger");
        this.OTPSuccessForgotPassword.removeClass("text-success");
        this.OTPSuccessForgotPassword.html("Enter the Correct OTP");
      }
    }
    return flag;
  };

  doSaveNewForgotPassword = () => {
    let newPassword = this.saveNewPasswordInputForgotPassword.val();
    let newPassValidation = this.passwordvalidate1();

    if (newPassValidation) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/customer/Account/setNewPasswordOnForgotPassword",
        data: {
          Password: newPassword, //Password column name
          Phone_Number: oldPhone,
        },
        headers: { Authorization: X_API_KEY },
        success: (res) => {
          $("#otp-labelForgetPasswordAccount").val("");
          $("#newForgetPasswordAccount").val("");
          $("#success-New-PasswordAccount").html("");
          $("#OTP-successAccount").html("");
          $("#otp-inputForgetPasswordAccount").val("");

          window.$("#forgotpassModalForServicingSecurityPage").modal("hide");
          window.$("#passwordChangedSuccesfully").modal("show");

          //reset forgot pssword to original
          this.sendOTPForgotPasswordButton.removeClass("d-none");
          this.forgotPswdMobileNumberInput.removeClass("d-none");
          this.mobileLabelForgotPassword.removeClass("d-none");
          this.saveNewPasswordBtnForgotPassword.addClass("d-none");
          this.newPasswordLabelForgotPassword.addClass("d-none");
          this.saveNewPasswordInputForgotPassword.addClass("d-none");

          //add redirection to loginpage on password change
          //erasing the cookies
          setInterval(this.redirectToLogIn, 500);
        },
      });
    }
  };

  order_list = async () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderListCount",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: async (result) => {
        if (result["Total_Customer_Orders"] == 0) {
          $("#NoCurrentOrders").removeClass("d-none");
        } else {
          //Create Pagination
          $(".ordersPaginationMain").removeClass("d-none");
          //if pagination exists then remove it
          $(".ordersPaginationLink[value='1']").nextAll().remove();

          var totalOrders = parseInt(result["Total_Customer_Orders"]);
          pages = Math.ceil(totalOrders / 10);

          var pageLinks = "";
          for (let i = 2; i <= pages; i++) {
            pageLinks += `<li class="page-item ordersPaginationLink" value="${i}"><a class="page-link" href="#">${i}</a></li>`;
          }

          $(".ordersPaginationLink[value='1']").after(pageLinks);

          //onclick event for pagination
          $(".ordersPaginationLink").off("click");
          $(".ordersPaginationLink").on("click", this.paginationforOrders);

          //Show Orders on the page with limit of 10
          await this.getOrderList(0);
        }
        //this.showPreviousOrdersOnServicingPage(result)
      },
      error: (result) => {},
    });
  };

  paginationforOrders = async (event) => {
    var currentActivePage = $(".ordersPaginationLink.active");
    currentActivePage = currentActivePage[0];

    //currentActivePage = parseInt(currentActivePage);
    currentActivePage = currentActivePage.value;
    var clickedPage = parseInt(event.currentTarget.value);

    // -1 is for previous
    //0 is for next
    if (clickedPage == -1) {
      if (currentActivePage == 1) {
      } else {
        await this.getOrderList((currentActivePage - 1) * 10 - 10);
        $(".ordersPaginationLink.active").removeClass("active");
        currentActivePage = currentActivePage - 1;

        $(`.ordersPaginationLink[value="${currentActivePage}"]`).addClass(
          "active",
        );
      }
    } else if (clickedPage == 0) {
      if (currentActivePage == pages) {
      } else {
        await this.getOrderList((currentActivePage + 1) * 10 - 10);
        $(".ordersPaginationLink.active").removeClass("active");
        currentActivePage = currentActivePage + 1;

        $(`.ordersPaginationLink[value="${currentActivePage}"]`).addClass(
          "active",
        );
      }
    } else {
      await this.getOrderList((clickedPage - 1) * 10);
      $(".ordersPaginationLink.active").removeClass("active");
      $(`.ordersPaginationLink[value="${clickedPage}"]`).addClass("active");
    }
  };

  getOrderList = async (offset) => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderListWithOffset",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: {
        Offset: offset,
      },
      success: (result) => {
        //show orders on page
        this.showPreviousOrdersOnServicingPage(result);
      },

      error: (result) => {},
    });
  };

  //use query parameter to pass to php controller
  showPreviousOrdersOnServicingPage = (result) => {
    //Clearing any previous results
    $("#DesktopPastOrder").empty();
    $("#MobilePastOrder").empty();

    if (result && Array.isArray(result)) {
      result.forEach(async (element) => {
        //check if order is not yet accepted for cancel button
        if (element.Order_Status == "ENQUIRY RECEIVED") {
          var orderButton = `<button class="btn btn-sm px-4 py-2 cancelOrderButton" type="button" style="background-color: #ff385c; color:white;" value="${element.Order_ID}">CANCEL ENQUIRY</button>`;
        } else {
          var orderButton = `<button class="btn btn-sm px-4 py-2 reOrderButton" type="button" style="background-color: #ff385c; color:white;" value="${element.Order_ID}">RE-ENQUIRE</button>`;
        }

        //Creating Order Products Paragraph
        var orderProducts = element.Order_products;
        var orderProductsSummary = ``;
        if (orderProducts && Array.isArray(orderProducts)) {
          orderProducts.forEach((product) => {
            orderProductsSummary =
              orderProductsSummary +
              `${product.ProductName} X ${product.Quantity},`;
          });
        }
      //Removing last comma
      orderProductsSummary = orderProductsSummary.slice(0, -1);

      if (deviceTypeCustSerOrdersPage == "desktop") {
        var vendorImg = getVendorBusinessImageUrl(element.Vendor_Image, 1);

        var item = `<div class="card mb-2 border border-3 ml-4 mr-1">
        <div class="card-body">
            <div class="row">
                <div class="col-2 col-lg-2 col-xl-1">
                    <img src="${vendorImg}" class="img-load" width="100%">
                </div>
                <div class="col-7"">

                      <h4 class="mb-1">${element.Vendor_Name}</h4>
                      <p class="mb-0">${element.Vendor_Address.City}</p>
                      <p class="display-6 mb-0" style="color: gray;">ENQUIRY #${
                        element.Order_No
                      } | ${element.Booked_Date_and_Time}</p>
                      <!-- <button type="button" class="btn" style="color: #ff385c;">VIEW DETAILS</button> -->
                      <button class="btn view-order-details-button" type="button" style="color: #ff385c; margin-left:-1rem;" value="${
                        element.Order_ID
                      }">VIEW DETAILS</button>
                  </div>

                  <div class="col">
                      <p class="d-flex justify-content-end display-6">${
                        element.Order_Status
                      } on ${element.Updated_Status_Time}</p>
                  </div>
              </div>
              <hr>
              <div class="row">
                  <div class="col-9">
                      <p>${orderProductsSummary}</p>
                      <div class="d-grid gap-2 d-md-block">
                          ${orderButton}
                          <a class="btn btn-sm px-4 py-2" type="button" style="background-color: #ff385c; color:white;" href="${
                            baseURL +
                            "customer/confirmationPage/" +
                            element.Order_No
                          }" target="_blank">TRACK ENQUIRY</a>
                          <button class="btn btn-sm btn-outline-warning px-4 py-2 ml-3 orderServicingHelp" type="button" value="${
                            element.Order_ID
                          }">HELP</button>
                      </div>
                  </div>
                  <div class="col-3">
                      <p class="d-flex justify-content-end">Total Amount: ${
                        element.Total_Amount
                      }</p>
                  </div>
              </div>

          </div>
      </div>`;

        $("#DesktopPastOrder").append(item);
      } else {
        //mobile view for top products
        var item = `<div class="card ml-3 mr-3 border border-3 mb-1">
          <div class="card-body ">
                  <div class="row">
                      <h4 class=" truncate2">${element.Vendor_Name}</h4>
                      <p class="mb-1">Margao</p>
                      <p class="m-0">Total Amount: Rs. ${
                        element.Total_Amount
                      }<button class="btn border-0 view-order-details-button" value="${
                        element.Order_ID
                      }"><img src="https://img.icons8.com/ios-filled/16/null/forward--v1.png" /></button></p>
                  </div>

              <hr>
              <div class="row ">

                  <div class="col-7">
                      <p class="card-text truncate" style="font-size:0.8rem;"><b>${orderProductsSummary}</b></p>
                  </div>

                  <div class="col-5">
                      <p class="d-flex justify-content-end m-0" style="font-size:0.8rem;">Total Amount: ${
                        element.Total_Amount
                      }</p>
                  </div>
              </div>

              <div class="d-grid gap-2 d-md-block">
                  ${orderButton}
                  <a class="btn btn-sm btn-outline-warning px-3" type="button" href="${
                    baseURL + "customer/confirmationPage/" + element.Order_No
                  }">TRACK ENQUIRY</a>
                  <button class="btn btn-sm btn-outline-warning px-3 orderServicingHelp" type="button" value="${
                    element.Order_ID
                  }">HELP</button>
              </div>

              <!-- </div> -->
          </div>
      </div>`;

        $("#MobilePastOrder").append(item);
      }

      $(".view-order-details-button").off("click");
      $(".view-order-details-button").on("click", this.viewOrderDetails);

      $(".cancelOrderButton").off("click");
      $(".cancelOrderButton").on("click", this.showcancelOrderModalFunction);

      $(".reOrderButton").off("click");
      $(".reOrderButton").on("click", this.reOrderFunction);

      //help orders
      $(".orderServicingHelp").off("click");
      $(".orderServicingHelp").on("click", async (e) => {
        await this.orderServicingHelp(e);
      });
    });
  }
};

  viewOrderDetails = (event) => {
    var orderDetailsProducts = ``;
    var orderID = event.currentTarget.value;

    //Get order Details
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderDetailsAccountServicing",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: {
        Order_ID: orderID,
      },
      success: (result) => {
        //show order details on the modal
        var order = result.Order;
        var orderProducts = result.Order_products;
        orderProducts.forEach((product) => {
          var vegNonVegFlag = ``;
          if (product.Veg_NonVeg_flag == 0) {
            vegNonVegFlag = `<img src="https://img.icons8.com/color/16/null/vegetarian-food-symbol.png" class="img-fluid"></img>`;
          } else if (product.Veg_NonVeg_flag == 1) {
            vegNonVegFlag = `<img src="https://img.icons8.com/color/16/null/non-vegetarian-food-symbol.png" class="img-fluid"></img>`;
          }
          orderDetailsProducts += `<div class="d-flex justify-content-between">
              <p class="text-muted mb-0 p-2 col-8">${vegNonVegFlag} ${product.ProductName} x ${product.Quantity} </p>
              <p class="text-muted mb-0 p-2">₹ ${product.Price}</p>
              </div>`;
        });
        $(".order-details-products").html(orderDetailsProducts);
        $(".order-details-itemsTotal").html(order.Order_Amount);
        $(".order-details-gstAmount").html(order.GST);
        $(".order-details-offersDiscount").html(
          parseInt(order.Offers_Discount) + parseInt(order.Coupon_discount),
        );
        $(".order-details-packagingCharges").html(order.Packaging_charges);
        $(".order-details-deliveryCharges").html(order.Delivery_Charges);
        $(".order-details-totalPrice").html(order.Final_Bill_Amount);
        window.$("#viewDetailsModalForServicingOrdersPage").modal("show");
      },

      error: (result) => {},
    });
  };

  reOrderFunction = async (event) => {
    var orderID = event.currentTarget.value;

    var cart = await CartObject.cartCheck();
    var cartLength = (cart && cart.Products) ? cart.Products.length : 0;
    if (cartLength == 0) {
      var deleteCart = "YES";
    } else {
      var deleteCart = "NO";
    }

    $.ajax({
      url: baseURL + "api/customer/Cart/RepeatOrder",
      type: "POST",
      data: {
        CUSTOMER_ID: customerID,
        Order_ID: orderID,
        deleteCart: deleteCart,
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        if (result == "Items Exist in Cart") {
          $("#customerDeleteCartModalOrderID").val(orderID);
          window.$("#customerDeleteCartModal").modal("show");
        } else if (result == "Some Products Currently Not Authorized") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Some Products Currently Not Available") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Some Products Not Found") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Error Can only repeat Menu flow") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Vendor not authorized") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Vendor not available") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Vendor not found") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else if (result == "Order not found") {
          $(".customerOrderErrorModalMessage").html(result);
          window.$("#customerOrderErrorModal").modal("show");
        } else {
          $.ajax({
            url: baseURL + "api/customer/CustomerCookies/setSessionId",
            type: "POST",
            data: {
              data: {
                ORDER_ID: result,
              },
            },
            success: (result) => {
              window.location = baseURL + `customer/cart`;
            },
            error: (error) => {},
          });
        }
      },
      error: (error) => {},
    });
  };

  reOrderAfterEmptyCartFunction = () => {
    window.$("#customerDeleteCartModal").modal("hide");
    var orderID = $("#customerDeleteCartModalOrderID").val();

    $.ajax({
      url: baseURL + "api/customer/Cart/RepeatOrder",
      type: "POST",
      data: {
        CUSTOMER_ID: customerID,
        Order_ID: orderID,
        deleteCart: "YES",
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $.ajax({
          url: baseURL + "api/customer/CustomerCookies/setSessionId",
          type: "POST",
          data: {
            data: {
              ORDER_ID: result,
            },
          },
          success: (result) => {
            window.location = baseURL + `customer/cart`;
          },
          error: (error) => {},
        });
      },
      error: (error) => {},
    });
  };

  //cancel order modal
  showcancelOrderModalFunction = (event) => {
    cancelOrderId = event.currentTarget.value;
    window.$("#customerOrderCancelModal").modal("show");
    $(".customerOrderCancelModalSubmitButton").on(
      "click",
      this.showcancelOrderFunction,
    );
  };
  //cancel order api call
  showcancelOrderFunction = () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderCancel",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: {
        Order_ID: cancelOrderId,
      },
      success: async (res) => {
        window.$("#customerOrderCancelModal").modal("hide");

        //location.reload();

        //reloading the order part
        var currentActivePage = $(".ordersPaginationLink.active");
        currentActivePage = currentActivePage[0];
        currentActivePage = currentActivePage.value;

        await this.getOrderList((currentActivePage - 1) * 10);
      },
      error: (err) => {},
    });
  };

  orderServicingHelp = async (event) => {
    var helpOrder = event.currentTarget.value;

    $.ajax({
      url: baseURL + "api/customer/CustomerCookies/setSessionId",
      type: "POST",
      data: {
        data: { HELP_REQUESTED: helpOrder },
      },
      success: (res) => {
        this.checkHelpRequested(res);
      },
      error: (err) => {},
    });
  };

  customerHelpList = () => {
    // $.ajax({
    //   async: false,
    //   url: baseURL + "api/customer/Help/customerHeadings",
    //   type: "GET",
    //   success: (result) => {
    //     result.forEach((helpItem) => {
    //       $.ajax({
    //         url: baseURL + "api/customer/Help/customerSubHeadings",
    //         type: "POST",
    //         async: false,
    //         data: {
    //           Parent_ID : helpItem.id,
    //         },
    //         success: (result) => {
    //
    //         },
    //         error: (result) => {
    //
    //         },
    //       });
    //     })
    //   },
    //   error: (result) => {
    //
    //   },
    // });

    $.ajax({
      url: baseURL + "api/customer/Help/customerHeadingsAndSubHeadings",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        helpList = result;
        var parentHelpItem = "";
        $(".customerServicingHelpItems").empty();
        if (result && Array.isArray(result)) {
          result.forEach((helpItem) => {
            if (parentHelpItem == helpItem.HeadingID) {
              var subheading = `<div class="accordion-item">
              <h2 class="accordion-header" id="sub-heading-${helpItem.SubHeadingID}">
                  <button class="accordion-button" style="color: #ff385c;" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${helpItem.SubHeadingID}" aria-expanded="false" aria-controls="collapseOne">
                      ${helpItem.SubHeadingTitle}
                  </button>
              </h2>
              <div id="collapse-${helpItem.SubHeadingID}" class="accordion-collapse collapse" aria-labelledby="sub-heading-${helpItem.SubHeadingID}" data-bs-parent="#accordionExample-${helpItem.HeadingID}">
                  <div class="accordion-body">
                  <div class="col-12 mb-3">${helpItem.SubHeadingDescription}</div>
                  <button type="button" class="btn btn-sm rounded-4 text-white mb-2 " style="background-color: #ff385c;" data-bs-toggle="modal" data-bs-target="#CustomerHelpEmailModal" value = "${helpItem.SubHeadingID}">
                  Drop an Email
              </button>
                      <strong>
                          <p class="text-muted">We will revert back within 24-48 hours with your query</p>
                      </strong>
                  </div>
              </div>
          </div>`;

              $(`.${helpItem.HeadingID}-sub-items`).append(subheading);
            } else {
              var parentAccordian = `<div class="accordion-item">
              <h2 class="accordion-header" id="flush-heading-${helpItem.HeadingID}">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse-${helpItem.HeadingID}" aria-expanded="false" aria-controls="flush-collapseEight">
                  <strong>${helpItem.HeadingTitle}</strong>
                  </button>
              </h2>
              <div id="flush-collapse-${helpItem.HeadingID}" class="accordion-collapse collapse" aria-labelledby="flush-heading-${helpItem.HeadingID}" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                  ${helpItem.HeadingDescription}
                  <span class="${helpItem.HeadingID}-inner-accordian">
                      
                    </span>
                  </div>
              </div>
          </div>`;
              $(".customerServicingHelpItems").append(parentAccordian);

              //check if inner accordian is necessary
              if (helpItem.SubHeadingID != null) {
                var innerAccordian = `<div class="accordion mt-3 mb-3 ${helpItem.HeadingID}-sub-items" id="accordionExample-${helpItem.HeadingID}">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="sub-heading-${helpItem.SubHeadingID}">
                        <button class="accordion-button" style="color: #ff385c;" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${helpItem.SubHeadingID}" aria-expanded="false" aria-controls="collapse-${helpItem.SubHeadingID}">
                            ${helpItem.SubHeadingTitle}
                        </button>
                    </h2>
                    <div id="collapse-${helpItem.SubHeadingID}" class="accordion-collapse collapse" aria-labelledby="sub-heading-${helpItem.SubHeadingID}" data-bs-parent="#accordionExample-${helpItem.HeadingID}">
                        <div class="accordion-body">
                        <div class="col-12 mb-3">${helpItem.SubHeadingDescription}</div>
                            <button type="button" class="btn btn-sm rounded-4 text-white mb-2 dropEmailButton" style="background-color: #ff385c;" data-bs-toggle="modal" data-bs-target="#CustomerHelpEmailModal" value="${helpItem.SubHeadingID}">
                                Drop an Email
                            </button>
                            <strong>
                                <p class="text-muted">We will revert back within 24-48 hours with your query</p>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>`;

                $(`.${helpItem.HeadingID}-inner-accordian`).append(
                  innerAccordian,
                );
              }
            }
            parentHelpItem = helpItem.HeadingID;
          });
        }
        $(".dropEmailButton").on("click", this.sendHelpEmail);
      },
      error: (result) => {},
    });
  };

  sendHelpEmail = (event) => {
    //
    //Show account email on help model
    $(".CustomerHelpEmailId").html(customerData.Email);
    $(".CustomerHelpEmailSubHeadingId").html(event.currentTarget.value);

    if (helpRequestedOrderID == null) {
      $(".CustomerHelpEmailModalOrderNumber").prop("disabled", false);
      $(".CustomerHelpEmailModalOrderNumber").prop("readonly", false);
      this.showAllOrderNumberInHelp();
    } else {
      $(".CustomerHelpEmailModalOrderId").val(helpRequestedOrderID);

      $(".CustomerHelpEmailModalOrderNumber > option:selected").prop(
        "selected",
        false,
      );
      $(".CustomerHelpEmailModalOrderNumber").append(
        `<option value="${helpRequestedOrderID}" selected></option>`,
      );

      this.showHelpOrderDetails();
    }

    $(".CustomerHelpEmailModalSubmitButton").on(
      "click",
      this.verifyHelpEmailDetails,
    );
  };

  verifyHelpEmailDetails = async () => {
    var canSendEmail = true;
    var helpEmailMessage = $("textarea#CustomerHelpEmailMessage").val();
    var helpEmailSubHeading = $(".CustomerHelpEmailSubHeadingId").text();
    var helpEmailOrderId = $(
      ".CustomerHelpEmailModalOrderNumber > option:selected",
    ).val();

    //verify message
    if (helpEmailMessage.length < 6) {
      canSendEmail = false;
      $(".CustomerHelpEmailMessageError").html("Enter Some Message");
      setTimeout(() => {
        $(".CustomerHelpEmailMessageError").html("");
      }, 5000);
    }

    if (canSendEmail == true) {
      //Verify email
      var email = customerData.Email_status;
      if (email.toLowerCase() == "invalid") {
        canSendEmail = false;
        $(".CustomerHelpEmailIdError").html("Email address is Invalid");
        setTimeout(() => {
          $(".CustomerHelpEmailIdError").html("");
        }, 10000);
      }
    }

    var orderExists = false;
    var emailOrderDetails;
    if (canSendEmail == true) {
      //verify orderID
      if (helpEmailOrderId == "") {
        canSendEmail = false;
        $(".CustomerHelpEmailModalOrderNumberError").html(
          "Select an Enquiry ID",
        );
        setTimeout(() => {
          $(".CustomerHelpEmailModalOrderNumberError").html("");
        }, 5000);
      } else {
        await new Promise((resolve) => {
          $.ajax({
            url: baseURL + "api/customer/Cart/OrderDetails",
            type: "POST",
            headers: { Authorization: X_API_KEY },
            data: {
              Order_ID: helpEmailOrderId,
            },
            success: (order) => {
              orderExists = true;
              emailOrderDetails = order.Order;
              resolve();
            },
            error: (result) => {
              resolve();
            },
          });
        });

        if (orderExists == false) {
          canSendEmail = false;
          $(".CustomerHelpEmailModalOrderIdError").html(
            "Enter a valid Enquiry ID",
          );
          setTimeout(() => {
            $(".CustomerHelpEmailModalOrderIdError").html("");
          }, 5000);
        } else {
          canSendEmail = true;
        }
      }
    }

    if (canSendEmail === true) {
      var awsEmailSubject;
      helpList.forEach((helpItem) => {
        if (helpItem.SubHeadingID == helpEmailSubHeading) {
          awsEmailSubject = helpItem.SubHeadingTitle;
        }
      });

      var emailData = {
        Subject: awsEmailSubject,
        Message: helpEmailMessage,
        Order: emailOrderDetails,
        customerEmail: customerData.Email,
      };

      this.sendAwsEmail(emailData);
    }
  };

  sendAwsEmail = (data) => {
    var BodyHtmlForVendor = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
    <html>
      <head>
        <!-- Compiled with Bootstrap Email version: 1.3.1 -->
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
        <meta http-equiv="x-ua-compatible" content="ie=edge">
        <meta name="x-apple-disable-message-reformatting">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <meta name="format-detection" content="telephone=no, date=no, address=no, email=no">
        <style type="text/css">
          body,table,td{font-family:Helvetica,Arial,sans-serif !important}.ExternalClass{width:100%}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div{line-height:150%}a{text-decoration:none}*{color:inherit}a[x-apple-data-detectors],u+#body a,#MessageViewBody a{color:inherit;text-decoration:none;font-size:inherit;font-family:inherit;font-weight:inherit;line-height:inherit}img{-ms-interpolation-mode:bicubic}table:not([class^=s-]){font-family:Helvetica,Arial,sans-serif;mso-table-lspace:0pt;mso-table-rspace:0pt;border-spacing:0px;border-collapse:collapse}table:not([class^=s-]) td{border-spacing:0px;border-collapse:collapse}@media screen and (max-width: 600px){.w-lg-48,.w-lg-48>tbody>tr>td{width:auto !important}.w-full,.w-full>tbody>tr>td{width:100% !important}.w-16,.w-16>tbody>tr>td{width:64px !important}.p-lg-10:not(table),.p-lg-10:not(.btn)>tbody>tr>td,.p-lg-10.btn td a{padding:0 !important}.p-2:not(table),.p-2:not(.btn)>tbody>tr>td,.p-2.btn td a{padding:8px !important}.pr-4:not(table),.pr-4:not(.btn)>tbody>tr>td,.pr-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-right:16px !important}.pl-4:not(table),.pl-4:not(.btn)>tbody>tr>td,.pl-4.btn td a,.px-4:not(table),.px-4:not(.btn)>tbody>tr>td,.px-4.btn td a{padding-left:16px !important}.pr-6:not(table),.pr-6:not(.btn)>tbody>tr>td,.pr-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-right:24px !important}.pl-6:not(table),.pl-6:not(.btn)>tbody>tr>td,.pl-6.btn td a,.px-6:not(table),.px-6:not(.btn)>tbody>tr>td,.px-6.btn td a{padding-left:24px !important}.pt-8:not(table),.pt-8:not(.btn)>tbody>tr>td,.pt-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-top:32px !important}.pb-8:not(table),.pb-8:not(.btn)>tbody>tr>td,.pb-8.btn td a,.py-8:not(table),.py-8:not(.btn)>tbody>tr>td,.py-8.btn td a{padding-bottom:32px !important}*[class*=s-lg-]>tbody>tr>td{font-size:0 !important;line-height:0 !important;height:0 !important}.s-4>tbody>tr>td{font-size:16px !important;line-height:16px !important;height:16px !important}.s-6>tbody>tr>td{font-size:24px !important;line-height:24px !important;height:24px !important}}
        </style>
      </head>
      <body class="bg-red-100" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
        <table class="bg-red-100 body" valign="top" role="presentation" border="0" cellpadding="0" cellspacing="0" style="outline: 0; width: 100%; min-width: 100%; height: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-family: Helvetica, Arial, sans-serif; line-height: 24px; font-weight: normal; font-size: 16px; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box; color: #000000; margin: 0; padding: 0; border-width: 0;" bgcolor="#ff385c">
          <tbody>
            <tr>
              <td valign="top" style="line-height: 24px; font-size: 16px; margin: 0;" align="left" bgcolor="#ff385c">
                <table class="container" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                  <tbody>
                    <tr>
                      <td align="center" style="line-height: 24px; font-size: 16px; margin: 0; padding: 0 16px;">
                        <!--[if (gte mso 9)|(IE)]>
                          <table align="center" role="presentation">
                            <tbody>
                              <tr>
                                <td width="600">
                        <![endif]-->
                        <table align="center" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td style="line-height: 24px; font-size: 16px; margin: 0;" align="left">
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <img class="w-16" src="https://Locaso-pro-data-public.s3.ap-south-1.amazonaws.com/Public_Pictures/LocasoWhiteWithoutOrange.png" style="height: auto; line-height: 100%; outline: none; text-decoration: none; display: block; width: 64px; border-style: none; border-width: 0;" width="64">
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="space-y-4">
                                  <h1 class="text-4xl fw-800" style="padding-top: 0; padding-bottom: 0; font-weight: 800 !important; vertical-align: baseline; font-size: 36px; line-height: 43.2px; margin: 0;" align="left">${customerData.Customer_Name} has raised an Issue</h1>
                                  <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <p class="" style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left"></p>
                                  <table class="s-4 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                    <tbody>
                                      <tr>
                                        <td style="line-height: 16px; font-size: 16px; width: 100%; height: 16px; margin: 0;" align="left" width="100%" height="16">
                                          &#160;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="card rounded-3xl px-4 py-8 p-lg-10" role="presentation" border="0" cellpadding="0" cellspacing="0" style="border-radius: 24px; border-collapse: separate !important; width: 100%; overflow: hidden; border: 1px solid #e2e8f0;" bgcolor="#ffffff">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 16px; width: 100%; border-radius: 24px; margin: 0; padding: 40px;" align="left" bgcolor="#ffffff">
                                        <h3 class="text-center" style="padding-top: 0; padding-bottom: 0; font-weight: 500; vertical-align: baseline; font-size: 28px; line-height: 33.6px; margin: 0;" align="center">Details</h3>
                                        <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Order #${data.Order.Order_No}</p>
                                        <p class="text-center text-muted" style="line-height: 24px; font-size: 16px; color: #718096; width: 100%; margin: 0;" align="center">Message : ${data.Message}</p>
                                        <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                &#160;
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <table class="hr" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 16px; border-top-width: 1px; border-top-color: #e2e8f0; border-top-style: solid; height: 1px; width: 100%; margin: 0;" align="left">
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                          <tbody>
                                            <tr>
                                              <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                                &#160;
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <p style="line-height: 24px; font-size: 16px; width: 100%; margin: 0;" align="left">If you have any questions, contact us at <a href="" style="color: #0d6efd;"><span class="__cf_email__" data-cfemail="40082930032f3230002538212d302c256e232f2d">customer.support@Locaso.com</span></a>.</p>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table class="s-6 w-full" role="presentation" border="0" cellpadding="0" cellspacing="0" style="width: 100%;" width="100%">
                                  <tbody>
                                    <tr>
                                      <td style="line-height: 24px; font-size: 24px; width: 100%; height: 24px; margin: 0;" align="left" width="100%" height="24">
                                        &#160;
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if (gte mso 9)|(IE)]>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                        <![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      <script data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"></script></body>
    </html>`;
    $.ajax({
      url: baseURL + "api/AmazonSesSmtp/sendCustomerHelpEmail",
      type: "POST",
      data: {
        CustomerEmail: data.customerEmail,
        Subject: data.Subject,
        BodyText: `CUSTOMER SUPPORT`,
        BodyHtml: BodyHtmlForVendor,
      },
      success: (result) => {
        this.unsetHelpRequested();
        window.$("#CustomerHelpEmailModal").modal("hide");

        $(".CustomerHelpConfirmationEmailMessage").html(
          "Your Email has been sent Successfully",
        );
        window.$("#CustomerHelpConfirmationEmail").modal("show");
        setTimeout(() => {
          window.$("#CustomerHelpConfirmationEmail").modal("hide");
        }, 3000);
      },
      error: (error) => {
        $(".CustomerHelpConfirmationEmailMessage").html(
          "Some Error occured, Try Again.",
        );
        window.$("#CustomerHelpConfirmationEmail").modal("show");
        setTimeout(() => {
          window.$("#CustomerHelpConfirmationEmail").modal("hide");
        }, 7000);
      },
    });
  };

  unsetHelpRequested = () => {
    $.ajax({
      url: baseURL + "api/customer/CustomerCookies/unsetSessionValues",
      type: "POST",
      data: {
        unset: "HELP_REQUESTED",
      },
      success: (result) => {
        helpRequestedOrderID = "";
      },
      error: (error) => {},
    });
  };

  showAllOrderNumberInHelp = () => {
    $.ajax({
      url: baseURL + "api/customer/Cart/OrderList",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        if (result && Array.isArray(result)) {
          result.forEach((order) => {
            var item = `<option value="${order.Order_ID}">#${order.Order_No}</option>`;
            $(".CustomerHelpEmailModalOrderNumber").append(item);
          });
          $(".CustomerHelpEmailModalOrderNumber").on(
            "change",
            this.showHelpOrderDetails,
          );
        }
      },
      error: (result) => {},
    });
  };

  showHelpOrderDetails = () => {
    var orderIdExists = false;
    //var helpEmailOrderId = $(".CustomerHelpEmailModalOrderId").val();
    var helpEmailOrderId = $(
      ".CustomerHelpEmailModalOrderNumber > option:selected",
    ).val();

    $.ajax({
      url: baseURL + "api/customer/Cart/OrderDetails",
      type: "POST",
      headers: { Authorization: X_API_KEY },
      data: {
        Order_ID: helpEmailOrderId,
      },
      success: (result) => {
        var order = result.Order;

        if (helpRequestedOrderID != "") {
          $(".CustomerHelpEmailModalOrderNumber > option:selected").html(
            `#${order.Order_No}`,
          );
        }

        //show order details on the help modal
        $(".CustomerHelpEmailModalOrderIdError").html("");
        $(".CustomerHelpEmailorderDetailsSection").removeClass("d-none");
        $(".CustomerHelpEmailModalOrderDate").val(order.Order_booked_date_time);
        $(".CustomerHelpEmailModalOrderAmount").val(order.Final_Bill_Amount);
        orderIdExists = true;
      },

      error: (result) => {},
    });

    if (orderIdExists == false) {
      $(".CustomerHelpEmailModalOrderNumberError").html(
        "Some Error Occured. Select Again.",
      );
      $(".CustomerHelpEmailorderDetailsSection").addClass("d-none");
      setTimeout(() => {
        $(".CustomerHelpEmailModalOrderIdError").html("");
      }, 5000);
    }
  };

  //ADDRESSS SECTION

  //validations for address
  addAdressValidationCheck = (e) => {
    e.preventDefault();

    let isAddressNameValidated = this.AddressName_validate();
    if (isAddressNameValidated) {
      this.inputAddressNameError.html("");
    }

    let isAddressValidated = this.Address_validate();
    if (isAddressValidated) {
      this.inputAddressError.html("");
    }

    let isAddressshortValidated = this.Addressshort_validate();
    if (isAddressshortValidated) {
      this.inputAddressshortError.html("");
    }

    // let isLandmarkValidated = this.Landmark_validate();
    // if (isLandmarkValidated) {
    //
    //   this.inputLandmarkError.html("");
    // }

    let isCityValidated = this.City_validate();
    if (isCityValidated) {
      this.inputCityError.html("");
    }

    let isStateValidated = this.State_validate();
    if (isStateValidated) {
      this.inputStateError.html("");
    }

    let isPincodeValidated = this.Pincode_validate();
    if (isPincodeValidated) {
      this.inputpincodeError.html("");
    }

    if (
      isAddressNameValidated &&
      isAddressValidated &&
      isAddressshortValidated &&
      isCityValidated &&
      isStateValidated &&
      isPincodeValidated
    ) {
      this.submitNewAdress();
    }
  };

  AddressName_validate = () => {
    let flag = true;

    if (this.inputAddressName.val().length < 4) {
      this.inputAddressNameError.html(
        "Address Name should be minimum 4 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  Address_validate = () => {
    let flag = true;

    if (this.inputAddress.val().length < 5) {
      this.inputAddressError.html(
        "Address should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  Addressshort_validate = () => {
    let flag = true;
    if (this.inputAddressshort.val().length < 5) {
      this.inputAddressshortError.html(
        "Landmark should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  City_validate = () => {
    let flag = true;

    var cityExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputCity.val().match(cityExample) ||
      this.inputCity.val().length < 3
    ) {
      this.inputCityError.html(
        "City should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  State_validate = () => {
    let flag = true;

    var stateExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputState.val().match(stateExample) ||
      this.inputState.val().length < 3
    ) {
      this.inputStateError.html(
        "State should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  Pincode_validate = () => {
    let flag = true;

    var pincodeExample = /^[0-9]*$/;

    if (
      !this.inputPincode.val().match(pincodeExample) ||
      this.inputPincode.val().length < 6
    ) {
      this.inputpincodeError.html(
        "Pincode should be minimum 6 characters long and should contain only numbers!",
      );

      flag = false;
    }

    return flag;
  };

  //validations for editing address
  editAdressValidationCheck = (e) => {
    e.preventDefault();

    let isAddressNameValidated = this.editAddressName_validate();
    if (isAddressNameValidated) {
      this.inputAddressNameErrorEdit.html("");
    }

    let isAddressValidated = this.editAddress_validate();
    if (isAddressValidated) {
      this.inputAddressErrorEdit.html("");
    }

    let isAddressshortValidated = this.editAddressshort_validate();
    if (isAddressshortValidated) {
      this.inputAddressshortErrorEdit.html("");
    }

    // let isLandmarkValidated = this.Landmark_validate();
    // if (isLandmarkValidated) {
    //
    //   this.inputLandmarkError.html("");
    // }

    let isCityValidated = this.editCity_validate();
    if (isCityValidated) {
      this.inputCityErrorEdit.html("");
    }

    let isStateValidated = this.editState_validate();
    if (isStateValidated) {
      this.inputStateErrorEdit.html("");
    }

    let isPincodeValidated = this.editPincode_validate();
    if (isPincodeValidated) {
      this.inputpincodeErrorEdit.html("");
    }

    if (
      isAddressNameValidated &&
      isAddressValidated &&
      isAddressshortValidated &&
      isCityValidated &&
      isStateValidated &&
      isPincodeValidated
    ) {
      this.editAddressDetailsAccount();
    }
  };

  editAddressName_validate = () => {
    let flag = true;

    if (this.inputAddressNameEdit.val().length < 4) {
      this.inputAddressNameErrorEdit.html(
        "Address Name should be minimum 4 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  editAddress_validate = () => {
    let flag = true;

    if (this.inputAddressEdit.val().length < 5) {
      this.inputAddressErrorEdit.html(
        "Address should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  editAddressshort_validate = () => {
    let flag = true;
    if (this.inputAddressshortEdit.val().length < 5) {
      this.inputAddressshortErrorEdit.html(
        "Landmark should be minimum 5 characters long!",
      );

      flag = false;
    }

    return flag;
  };

  editCity_validate = () => {
    let flag = true;

    var cityExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputCityEdit.val().match(cityExample) ||
      this.inputCityEdit.val().length < 3
    ) {
      this.inputCityErrorEdit.html(
        "City should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  editState_validate = () => {
    let flag = true;

    var stateExample = /^[A-Za-z0-9 ]+$/;

    if (
      !this.inputStateEdit.val().match(stateExample) ||
      this.inputStateEdit.val().length < 3
    ) {
      this.inputStateErrorEdit.html(
        "State should be minimum 3 characters long and should not contain special characters!",
      );

      flag = false;
    }

    return flag;
  };

  editPincode_validate = () => {
    let flag = true;

    var pincodeExample = /^[0-9]*$/;

    if (
      !this.inputPincodeEdit.val().match(pincodeExample) ||
      this.inputPincodeEdit.val().length < 6
    ) {
      this.inputpincodeErrorEdit.html(
        "Pincode should be minimum 6 characters long and should contain only numbers!",
      );

      flag = false;
    }

    return flag;
  };

  //adding new address
  submitNewAdress = () => {
    $.ajax({
      url: baseURL + "api/customer/Account/AddAddress",
      type: "POST",
      data: {
        // Customer_ID: 'b27e453c-c54d-404f-b377-d3e67c90fca0',
        Customer_ID: customerID,
        Address_Line_1: this.inputAddress.val(),
        Landmark: this.inputAddressshort.val(),
        City: this.inputCity.val(),
        State: this.inputState.val(),
        Pincode: this.inputPincode.val(),
        Address_Name: this.inputAddressName.val(),
        lat: $(".inputLatChangeAccount").val(),
        lon: $(".inputLonChangeAccount").val(),
      },
      headers: { Authorization: X_API_KEY },
      success: async (res) => {
        //check if user has address
        window.$("#locationModalAccountCall").modal("hide");
        $(".customerAccountSavedAddress").empty();
        await this.showCustomerAddress();
      },
      error: (err) => {},
    });
  };

  //display customer address
  showCustomerAddress = () => {
    // var allCookies = UtilObject.getAllCookies();
    // var customerID = allCookies.CUSTOMER_ID;
    $.ajax({
      url: baseURL + "api/customer/Account/getAddress",
      type: "POST",
      data: {
        // Customer_ID: 'b27e453c-c54d-404f-b377-d3e67c90fca0',
        Customer_ID: customerID,
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $(".customerAccountSavedAddress").empty();

        if (result && Array.isArray(result)) {
          result.forEach((element) => {
          var item = `<div class="col-sm-6 pt-2  ${element.Customer_Address_ID}">
          <label class="h-100 card rounded-1 shadow-sm mb-1 ml-2">
              <input type="hidden" name="customerAddressIdAccount" class="" value="${element.Customer_Address_ID}" />
              <div class="card-body">
                  <h5 class="card-title">${element.Address_Name}</h5>
                  <div class="h-50 truncate-cart-address">
                      <div id="${element.Customer_Address_ID}" class="card-text" style="width: 100%; 
                        line-height: 20px">${element.Address_Line_1}</div>
                  </div>
                  <input type="hidden" name="lat" value="${element.lat}" />
                  <input type="hidden" name="lon" value="${element.lon}" />
                  <div class="row pb-2">
                      <div class="col d-flex justify-content-start"> <button class="btn btn-sm customerAccountAddressEdit locationModalAccountEdit" type="button" style="color: #ff385c;" data-bs-toggle="modal" data-bs-target="#locationModalAccountCallEdit">Edit
                              <input type="hidden" name="customerAddressIdAccount" value="${element.Customer_Address_ID}" />
                          </button>
                      </div>
                      <div class="col  d-flex justify-content-end"> <button class="btn btn-sm customerAccountAddressDelete" type="button" style="color: #ff385c;">Delete
                              <input type="hidden" name="customerAddressIdAccount" value="${element.Customer_Address_ID}" />
                          </button>
                      </div>
                  </div>
              </div>
          </label>
      </div>`;
          $(".customerAccountSavedAddress").append(item);
        });
        $(".customerAccountSavedAddress .customerAccountAddressEdit").on(
          "click",
          this.editAddressDetailsAccountConfirm,
        );
          $(".customerAccountSavedAddress .customerAccountAddressDelete").on(
            "click",
            this.deleteAddressDeleteAccountConfirm,
          );
        }
      },
      error: (err) => {},
    });
  };

  //confirmation before editing customer address
  editAddressDetailsAccountConfirm = async (event) => {
    customerAddressId = $(event.currentTarget)
      .find("input[name='customerAddressIdAccount']")
      .val();

    $.ajax({
      url: baseURL + "api/customer/Account/getAddressViaCustomerAddressId",
      type: "POST",
      data: {
        Customer_Address_ID: customerAddressId,
      },
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        $(".inputAddressNameChangeAccountEdit").val(result.Address_Name);
        $(".inputAddressChangeAccountEdit").val(result.Address_Line_1);
        $(".inputAddressshortChangeAccountEdit").val(result.Landmark);
        $(".inputCityChangeAccountEdit").val(result.City);
        $(".inputStateChangeAccountEdit").val(result.State);
        $(".inputPincodeChangeAccountEdit").val(result.Pincode);
        oldLat = result.lat;
        oldLong = result.lon;
      },
      error: (result) => {},
    });

    //googles maps
    var classList = event.target.className.split(" ");
    var idOfGoogleMapsDiv = classList[classList.length - 1];

    addressDetails = await GoogleMapsApiObject.editAddress(
      idOfGoogleMapsDiv,
      oldLat,
      oldLong,
    );
    //google maps
  };

  //editing customer address
  editAddressDetailsAccount = () => {
    $.ajax({
      url: baseURL + "api/customer/Account/AddUpdateAddress",
      type: "POST",
      data: {
        // Customer_ID: 'b27e453c-c54d-404f-b377-d3e67c90fca0',
        Customer_ID: customerID,
        Customer_Address_ID: customerAddressId,
        Address_Line_1: this.inputAddressEdit.val(),
        Landmark: this.inputAddressshortEdit.val(),
        City: this.inputCityEdit.val(),
        State: this.inputStateEdit.val(),
        Pincode: this.inputPincodeEdit.val(),
        Address_Name: this.inputAddressNameEdit.val(),
        lat: $(".inputLatChangeAccountEdit").val() || $(".inputLat").val(),
        lon: $(".inputLonChangeAccountEdit").val() || $(".inputLon").val(),
      },
      headers: { Authorization: X_API_KEY },
      success: async (result) => {
        window.$("#locationModalAccountCallEdit").modal("hide");
        $(".customerAccountSavedAddress").empty();
        await this.showCustomerAddress();
      },
      error: (result) => {},
    });
  };

  //confirmation before delete customer address
  deleteAddressDeleteAccountConfirm = (event) => {
    customerAddressId = $(event.currentTarget)
      .find("input[name='customerAddressIdAccount']")
      .val();

    window.$(".deleteAddressConfirmationAccount").modal("show");
  };

  //delete customer address
  deleteAddressDeleteAccount = () => {
    window.$(".deleteAddressConfirmationAccount").modal("hide");

    $.ajax({
      url: baseURL + "api/customer/Account/DeleteAddress",
      type: "POST",
      data: {
        Customer_Address_ID: customerAddressId,
      },
      headers: { Authorization: X_API_KEY },
      success: async (result) => {
        $(".customerAccountSavedAddress").empty();
        await this.showCustomerAddress();
      },
      error: (result) => {},
    });
  };

  shareReferralCode = () => {
    const shareButton = document.querySelector(".share-button");
    const shareDialog = document.querySelector(".share-dialog");
    const closeButton = document.querySelector(".close-button");

    shareButton.addEventListener("click", (event) => {
      shareDialog.classList.add("is-open");
    });

    closeButton.addEventListener("click", (event) => {
      shareDialog.classList.remove("is-open");
    });
  };

  customerFavouriteList = () => {
    $.ajax({
      url: baseURL + "api/customer/Account/getFavorites",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        if (deviceTypeCustSerOrdersPage == "desktop") {
          $("#MobileFavourites").addClass("d-none");
          $("#DesktopFavourites").removeClass("d-none");

          $(".DesktopFavouriteitems").empty();
        } else {
          $("#DesktopFavourites").addClass("d-none");
          $("#MobileFavourites").removeClass("d-none");

          $(".MobileFavouriteitems").empty();
        }
        if (result && Array.isArray(result)) {
          result.forEach(async (element) => {
          if (deviceTypeCustSerOrdersPage == "desktop") {
            //for vendor review stars
            if (element.Vendor_Rating > 0) {
              var color = "background: #ff385c;";
            }
            var vendorImg = getVendorBusinessImageUrl(element.Image_URL, 1);

            var item = `<div class="col-12 col-md-4 col-xl-3 col-xxl-2">
            <div class="card mb-2 border border-3 ml-2 h-100">
            
                <div class="card-body mb-1">
                        <div class="w-100 favourites-container">
                        <a href="${baseURL}customer/productListing/${element.Vendor_URL}" rel="noopener"></a>
                        <img src="${vendorImg}" class="card-img-fluid rounded shadow-lg mb-3">
                        <button class="like-button" aria-label="Favourite" value="${element.Vendor_ID}" style="z-index:1040;">
                        <img src="https://img.icons8.com/emoji/48/null/heart-suit.png"/>
</button>
</div>
<a href="${baseURL}customer/productListing/${element.Vendor_URL}" rel="noopener">
                        <h5 class="card-text truncate">${element.Business_Name}</h5>
                        <div class="row">
                        <div class="col pr-0 d-flex justify-content-start">
                        <p class="mb-0 pt-2">Min Order:₹${element.Minimum_Order}</p>
                        </div>
                        <div class="col-4 pl-0 pt-1 d-flex justify-content-end" >
                          <p class="ratingBorder tec text-white mb-0 pl-1" style="${color}">${element.Vendor_Rating} <i class="fa fa-star mt-1" aria-hidden="true" style="color: white;"></i></p>
                        </div>
                           


                        </div>
                </div>
                </a>
            </div>
        </div>`;

            $(".DesktopFavouriteitems").append(item);
          } else {
            //for vendor review stars
            if (element.Vendor_Rating > 0) {
              var color = "background: #ff385c;";
            }

            //mobile view for favourites
            var vendorImg = getVendorBusinessImageUrl(element.Image_URL, 1);

            var item = `<div class="card mb-2 border border-3 ml-2">
            <div class="card-body">
                    <div class="row">
                        <div class="col-4 ml-2">
                            <img src="${vendorImg}" class="rounded float-start img-load">
                        </div>
        
                        <div class="col">
                            <div class="row">
                                <div class="col ml-1">
                                    <p class="card-text truncate">${element.Business_Name}</p>
                                    <!-- <p class="card-text truncate-one" style="color:gray;">Margao</p> -->
                                </div>
                            </div>        
                            <div class="row">
                                 <div class="col-8 pr-0">
                    <p class="mb-0 pt-1 tec">Min Order:₹${element.Minimum_Order}</p>
                    </div>
                    <div class="col mb-2 p-0 d-flex justify-content-end">
                    <p class="ratingBorder tec text-white mb-0 pl-1" style="${color}">${element.Vendor_Rating} <i class="fa fa-star mt-1" aria-hidden="true" style="color: white;"></i></p>
                    </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>`;

            $(".MobileFavouriteitems").append(item);
          }

          $(".like-button").off("click");
          $(".like-button").on("click", this.favouritesToggle);
        });}
      },
      error: (result) => {
        $(".DesktopFavouriteitems").empty();
        $(".MobileFavouriteitems").empty();
        $("#NoCurrentFavourites").removeClass("d-none");
      },
    });
  };

  favouritesToggle = (event) => {
    var favouritedID = event.currentTarget.value;

    $.ajax({
      url: baseURL + "api/customer/Account/AddRemoveFavorite",
      type: "POST",
      data: {
        Vendor_ID: favouritedID,
        Status: "false",
      },
      headers: { Authorization: X_API_KEY },
      success: async (result) => {
        await this.customerFavouriteList();
      },
      error: (error) => {},
    });
  };

  //GET all offers (replaces old coupons approach)
  getAllCoupons = () => {
    const container = $(".all-offers-grid");
    if (!container.length) return;

    container.html(`
      <div class="col-12 text-center py-5">
        <div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div>
      </div>`);

    $.ajax({
      url: baseURL + "api/customer/Homepage/getAllOffers",
      type: "GET",
      headers: { Authorization: X_API_KEY },
      success: (result) => {
        container.empty();
        const offers = Array.isArray(result) ? result : [];

        if (offers.length === 0) {
          container.html(`
            <div class="col-12">
              <div class="text-center py-5">
                <i class="fa fa-tags fa-3x mb-3" style="color:#ff385c; opacity:0.4;"></i>
                <h5 style="color:#3d4152;">No offers available right now</h5>
                <p class="text-muted">Please check back in some time.</p>
              </div>
            </div>`);
          return;
        }

        offers.forEach((offer) => {
          const imgUrl = getImageUrl(offer.Image_Url || "");
          let linkHref = `${baseURL}customer/allOffers`;
          if (offer.Go_To_Page === "vendor" && offer.offer_data) {
            linkHref = `${baseURL}customer/productListing/${offer.offer_data}`;
          } else if (offer.Go_To_Page === "category" && offer.offer_data) {
            linkHref = `${baseURL}customer/vendorListingPage/${offer.offer_data}`;
          }
          const endDate = offer.end_date ? offer.end_date.split(" ")[0] : "";

          const card = `
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <a href="${linkHref}" class="text-decoration-none d-block h-100">
                <div class="h-100" style="border-radius:16px;overflow:hidden;background:#fff;box-shadow:0 2px 12px rgba(0,0,0,0.08);transition:transform 0.2s,box-shadow 0.2s;"
                  onmouseover="this.style.transform='translateY(-4px)';this.style.boxShadow='0 8px 24px rgba(0,0,0,0.14)';"
                  onmouseout="this.style.transform='';this.style.boxShadow='0 2px 12px rgba(0,0,0,0.08)';">
                  <div style="position:relative;overflow:hidden;background:#f8f8f8;height:180px;">
                    <img src="${imgUrl}" alt="${offer.Offer_Name}"
                      onerror="this.src='${baseURL}assets/default.png';this.style.objectFit='contain';"
                      style="width:100%;height:100%;object-fit:cover;" />
                    <div style="position:absolute;top:10px;left:10px;background:#ff385c;color:#fff;font-size:0.75rem;font-weight:700;padding:3px 10px;border-radius:20px;">OFFER</div>
                  </div>
                  <div class="p-3">
                    <h6 style="font-weight:700;color:#3d4152;margin-bottom:4px;">${offer.Offer_Name}</h6>
                    ${endDate ? `<p class="text-muted mb-0" style="font-size:0.8rem;">Valid till: ${endDate}</p>` : ""}
                  </div>
                </div>
              </a>
            </div>`;
          container.append(card);
        });
      },
      error: () => {
        container.html(`
          <div class="col-12">
            <div class="text-center py-5">
              <i class="fa fa-exclamation-triangle fa-3x mb-3" style="color:#ff385c; opacity:0.4;"></i>
              <h5 style="color:#3d4152;">Unable to load offers</h5>
              <p class="text-muted">Please refresh and try again.</p>
            </div>
          </div>`);
      },
    });
  };

  //copy coupon code
  copyCode = (event) => {
    var code = $(event.currentTarget).find("input[name='couponCodeId']").val();

    // navigator.clipboard.writeText(code).then(() => {
    //   alert("Copied Coupon!");
    // });

    navigator.clipboard.writeText(code);
  };

  //logout
  logOutUser = () => {
    window.$("#logOutUserModal").modal("show");
  };

  //profile image upload
  profileImageUpload = async (e) => {
    if (this.checkImageValid()) {
      const base64Image = document.getElementById(
        "inpProfileImgPreviewCustomer",
      ).src;

      const formData = new FormData();
      formData.append("image", base64Image);

      const res = await fetch(baseURL + "api/customer/Account/uploadProfile", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      // close modal (keep your existing logic)
      $("#profilePhotoUpdate").removeClass("in");
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open");
      $("body").css("padding-right", "");
      $("#profilePhotoUpdate").hide();

      // refresh UI
      this.getAccountDetails();
    }
  };

  checkImageValid = () => {
    const img = document.getElementById("inpProfileImgPreviewCustomer");
    const src = img.getAttribute("src");

    var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
    if (!src) {
      $(".profileImageErrorCustomer").html(`Upload an image`);
      return false;
    } else {
      $(".profileImageErrorCustomer").html(``);
      return true;
    }
  };
}
